import React from "react";
import "./Contact.css";
import { color } from "framer-motion";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      
      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-info">
          <h5>CONTACT US</h5>
          <h2>Education & Environment Society</h2>

          {/* <p>
            <strong>Regd. Off:</strong><br />
            264/12 A (Third Floor), Shankar Marg <br />
            Mandawali, Delhi 110092 <br />
            📧 eesdelhi@yahoo.com
          </p>

          <p>
            <strong>MP Chapter:</strong><br />
            Hari Bhawan, Banthari, Mihona <br />
            Bhind, Madhya Pradesh 477441 <br />
            📧 eesmp@yahoo.com
          </p> */}


          <p>
  <strong>Regd. Off:</strong><br />
  264/12 A (Third Floor), Shankar Marg <br />
  Mandawali, Delhi 110092 <br />
  
  <span class="email">
    <i class="fa-solid fa-envelope"></i>
<a style={{ color: "black" }} href="mailto:eesdelhi@yahoo.com">
  eesdelhi@yahoo.com
</a>  </span>
</p>

<p>
  <strong>MP Chapter:</strong><br />
  Hari Bhawan, Banthari, Mihona <br />
  Bhind, Madhya Pradesh 477441 <br />
  
  <span class="email">
    <i class="fa-solid fa-envelope"></i>
   <a style={{ color: "black" }} href="mailto:eesmp@yahoo.com">eesmp@yahoo.com</a>
  </span>
</p>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="contact-form">
          <h3>Enquiry</h3>

       <form method="POST" action="contact.php">
  <input type="text" name="name" placeholder="Full Name" required />
  <input type="text" name="designation" placeholder="Designation" />
  <input type="text" name="company" placeholder="Company Name" />
  <input type="text" name="city" placeholder="City, Country" />
  <input type="tel" name="phone" placeholder="Mobile Number" required />
  <input type="email" name="email" placeholder="Email ID" required />
  <textarea name="message" placeholder="Type your enquiry here"></textarea>

  <button type="submit">Submit</button>
</form>
        </div>

      </div>

    </section>
  );
};

export default Contact;